import { ReplicatedAction } from "../../../core/game/interfaces/ReplicatedAction";
import { isValidEnglishWord } from "../util/Word";
;
export function getClueAnswerValidations(clueAnswer, gameState) {
    if (clueAnswer.length <= 0 || gameState.secretWord === undefined) {
        return false;
    }
    if (!isValidEnglishWord(clueAnswer)) {
        return `Clues must be valid English Words!`;
    }
    // Clue answer must match the revealed letters
    if (!clueAnswer.startsWith(gameState.secretWord.substring(0, gameState.numRevealedLetters))) {
        return `Clues must match the revealed letters!`;
    }
    // Clue must be one word alphanumeric
    if (!/^[a-zA-Z]+$/.test(clueAnswer)) {
        return `Your clue's answer must be one word and contain only letters and numbers!`;
    }
    // Clue must not be a previous clue
    if (gameState.previousClues.includes(clueAnswer)) {
        return `${clueAnswer} has already been guessed or given as a clue before!`;
    }
    return true;
}
function CreateClueValidator(data, context) {
    const { gameState } = context;
    if (data.clue.length <= 0 || gameState.secretWord === undefined) {
        return false;
    }
    //Clue answer validations
    const clueAnswerValidations = getClueAnswerValidations(data.clueAnswer, gameState);
    if (typeof (clueAnswerValidations) === 'string' || !clueAnswerValidations) {
        return clueAnswerValidations;
    }
    // Clue may not contain the answer in the clue
    if (data.clue.toLowerCase().includes(data.clueAnswer)) {
        return `You can't put the clue answer in the clue hint!`;
    }
    return true;
}
function CreateClueEffect(data, context) {
    context.createReplicatedObject('Clue', Object.assign(Object.assign({}, data), { isPrimaryClue: context.clue === undefined, hints: [data.clue] }));
    context.gameState.addPreviousClue(data.clueAnswer);
}
export const CreateClue = new ReplicatedAction('CreateClue', CreateClueValidator, CreateClueEffect);
//# sourceMappingURL=CreateClue.js.map